import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { PreferredLocationSubForm, Schema as PreferredLocationSchema } from '../subforms/PreferredLocation';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const BETStandardSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(PreferredLocationSchema(settings))
        .concat(DocumentsSchema(settings))
        .concat(OtherInformationSchema(settings))
);

export const BETStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={PreferredLocationSubForm} colors={colors} isRequired={true} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
        </>
    );
}